<div class="cursor-pointer d-inline-block mb-1" ngbDropdown placement="top-right">
  <button id="chart-settings" ngbDropdownToggle>
    <svg class="icon icon-18">
      <use xlink:href="/assets/img/svgs/svgset.svg#settings" />
    </svg>
  </button>
  <div ngbDropdownMenu aria-labelledby="chart-settings">
    @if (model.types?.length) {
      <h5>
        {{ 'instrument-detail.instrument-chart.types.headline' | transloco }}
      </h5>
      @for (type of model.types; track $index) {
        <button ngbDropdownItem [class.active]="type.isActive" (click)="changeType.emit(type.value)">
          {{ 'instrument-detail.instrument-chart.types.' + type.value | transloco }}
        </button>
      }
    }
  </div>
</div>
